module.exports = __webpack_public_path__ + "static/jiaji-icon.e99b81de.png";